import request from '@/utils/request'
export default {
  // 新增活动
  addOrEditActivity(method, data) {
    return request({
      url: '/system/activity',
      method: method,
      data
    })
  },
  // 查询活动
  getActivityList() {
    return request({
      url: '/system/activity/list',
      method: 'get'
    })
  },
  // 新增或修改任务
  addOrEditBaseTask(method,data) {
    return request({
      url:'/system/baseTask',
      method,
      data
    })
  },
  // 查询详情
  findBaseTask(id) {
    return request({
      url:`/system/baseTask/${id}`,
      method:'get'
    })
  },
  // 删除详情
  delBaseTask(data) {
    return request({
      url:'/system/baseTask',
      method:'delete',
      data
    })
  },
  // 查询任务列表
  getBaseTaskList() {
    return request({
      url:'/system/baseTask/list',
      method:'get'
    })
  }
}